import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  height: 10vh;
  width: calc(100% - 4rem);
  background-color: #fff;
  padding: 0 2rem;
  .logo-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 15%;
    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      color: #000;
      text-decoration: none;
      .navbarLogo {
        width: 25%;
        height: 25%;
        min-height: 30px;
        min-width: 30px;
      }
      h1 {
        width: 70%;
        font-family: "Roboto", sans-serif;
        display: none;
      }
    }
  }
  .hamburguer-menu-icon {
    width: 30px;
    height: 30px;
  }
  .navigation-container {
    display: none;
    flex-direction: column;
    list-style: none;
    width: fit-content;
    align-items: flex-end;
    justify-content: flex-start;
    width: 150px;
    padding: 0 1rem;
    position: absolute;
    top: 7vh;
    background: #fff;
    right: 0;
    height: 85vh;
    z-index: 10;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    &.active {
      display: flex;
    }
    ul {
      display: flex;
      flex-direction: column;
      list-style: none;
      width: fit-content;
      align-items: center;
      justify-content: space-between;
      width: fit-content;
      padding: 0;
      margin: 0;
      text-align: right;
      &:hover > .servicis-submenu {
        display: block;
      }
      li {
        list-style: none;
        width: fit-content;
        padding: 0;
        font-family: "Poppins";
        margin: 0;
        &:hover {
          font-size: 18px;
        }
        &.account-menu {
          color: #8c909e;
        }
        a {
          color: #333333;
          width: 100%;
          font-weight: 400;
          font-family: "Poppins";
          text-decoration: none;
          text-transform: uppercase;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .servicis {
        color: #000;
        font-weight: 700;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        padding: 20px;
        .servicis-submenu {
          display: none;
          top: 50px;
          right: 165px;
          width: 100px;
          padding: 0.5rem;
          position: absolute;
          background: #fff;
          box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
          z-index: 12;
          li {
            width: calc(100% - 1rem);
            border-bottom: 1px solid #ccc;
            padding: 0.5rem 0;
            text-align: left;
            &:hover {
              background: #ccc;
            }
            a {
              font-size: 12px;
              font-weight: 700;
            }
          }
        }
      }

      .servicis:hover > .servicis-submenu {
        display: block;
      }
      #logoutButton {
        .visible {
          display: block;
        }
        &.hidden {
          display: none;
        }
      }
    }
  }

  @media (min-width: 867px) {
    display: flex;
    .logo-container a {
      .navbarLogo {
        width: 10%;
      }
      h1 {
        width: auto;
        padding-left: 1rem;
        display: flex;
        justify-content: center;
      }
    }
    .hamburguer-menu-icon {
      display: none;
    }
    .navigation-container {
      width: 45%;
      display: flex;
      position: unset;
      top: 0;
      height: fit-content;
      box-shadow: none;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      ul {
        width: 100%;
        flex-direction: row;
        li {
          padding: 0 1rem 0 0;
          font-size: 16px;
          a {
            font-size: 16px;
          }
        }
        .servicis {
          font-size: 16px;
          .servicis-submenu {
            right: 0;
          }
        }
      }
    }
    .navigation-container ul .servicis .servicis-submenu {
      width: 150px;
      li a {
        font-size: 16px;
      }
    }
    .navigation-container ul li {
      padding: 20px;
    }
    .navigation-container ul li:hover {
      a {
        font-size: 18px;
      }
    }
  }
  @media (min-width: 1024px) {
    h1 {
      width: auto;
      display: flex;
      justify-content: center;
    }
    img {
      width: 20%;
    }
  }
  @media print {
    display: none;
  }
`;
